<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1350px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        block
        v-on="on"
      >
        Create Announcement
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Announcement"
      text="Create Announcement"
      class="mb-0"
    > 
      <v-container v-if="dialog">
        <v-row dense>
          <v-col
            :cols="isPublic ? '12': '5'"
            class="px-4"
          >
            <v-text-field
              v-model="title"
              v-validate="'required'"
              :error-messages="errors.collect('title')"
              data-vv-name="title"                
              label="Announcement Title"
              class="pb-5"
            />

            <tiptap-vuetify
              v-model="description"
              v-validate="'required'"
              :extensions="extensions"
              class="full-width text-editor-toolbar-height pb-1"
              :error-messages="errors.collect('description')"
              data-vv-name="description"
            />
            <span class="red--text text--lighten-1 caption">{{ errors.first('description') }}</span>

            <v-row dense>
              <v-col cols="6">
                <v-menu
                  v-model="announcementDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      label="Announcement Date"
                      prepend-icon="event"
                      readonly
                      :value="announcementDateDisplay"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="announcementDate"
                    no-title
                    @input="announcementDateMenu = false"
                  />
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  v-model="announcementCategoryId"
                  v-validate="'required'"
                  :items="announcementCategories"
                  item-text="name"
                  item-value="id"
                  value="id"
                  label="Announcement Category"
                  :error-messages="errors.collect('announcementCategoryId')"
                  data-vv-name="announcementCategoryId"
                  data-vv-as="announcement category"
                />
              </v-col>
              <v-col cols="6">
                <v-switch
                  v-model="isPublished"
                  class="px-2"
                  inset
                  :label="isPublished?'Publish Now' :'Not Publish'"
                />
              </v-col>
              <v-col cols="6">
                <v-switch
                  v-model="isPublic"
                  class="px-2"
                  inset
                  :label="isPublic?'Public' :'Private'"
                />
              </v-col>
              <v-col cols="12">
                <v-switch
                  v-model="acknowledgementRequired"
                  class="px-2"
                  inset
                  :label="acknowledgementRequired?'Acknowledgement Required' :'No Acknowledgement Required'"
                />
              </v-col>
            </v-row>
    
            <div class="font-weight-bold ">
              ATTACHMENTS
             
              <helper-auto-upload-file-input
                v-model="file"
                :max-size-in-mb="14" 
                :max-number="5"
                :multiple="true"
                data-vv-name="files"
                field-name="files"
                accept-type=".pdf"
                extension="ext:pdf"    
              >
                <span 
                  slot="activator"
                  class="mb-2"
                >   
                  <v-btn                    
                    :disabled="progressing"
                    class="mx-2"    
                    icon
                    color="primary"
                  >
                    <v-icon>
                      mdi-cloud-upload
                    </v-icon>
                  </v-btn>
                </span>
              </helper-auto-upload-file-input>
            </div>
            <div style="color:red">
              <i>(Total maximum size per upload is <bold>14 MB</bold>)</i>
            </div>
            
            <v-col
              cols="12"
              class="pa-0"
            >
              <span class="red--text text--lighten-1">{{ errors.first('files') }}</span>
              <span> 
                {{ file ? '' : 'No file chosen (.pdf only)' }}
              </span>
              <div
                v-if="file"
                class="mt-4"
              >
                <p
                  v-for="selectedFile in file.selectedFiles"
                  :key="selectedFile.name"
                  class="mb-0"
                >
                  <span class="font-weight-bold pl-2">{{ selectedFile.name }}</span>
                </p>
              </div>
            </v-col>

            <div class="font-weight-bold ">
              VIDEOS:    
              <v-btn                    
                class="mx-2"    
                icon
                color="primary"
                @click="addRow"
              >
                <v-icon>
                  mdi-cloud-upload
                </v-icon>
              </v-btn>

              <v-row
                v-for="(link, counter) in links"
                :key="counter"
                no-gutters
              >
                <v-col cols="10">
                  <v-text-field
                    v-model="link.path"
                    v-validate="'required'"
                    :error-messages="errors.collect('link')"
                    data-vv-name="link"                
                    label="Link"
                  />
                </v-col>
                <v-col
                  cols="2"
                  class="py-0 ma-auto"
                >
                  <v-icon
                    color="error"
                    @click="deleteRow(counter)"
                  >
                    mdi-window-close
                  </v-icon>
                </v-col>
              </v-row>
            </div>

            <v-col
              v-if="links.length < 1"
              cols="12"
              class="pa-0"
            >
              <span> 
                {{ 'No links available' }}
              </span>
            </v-col>
          </v-col>
          
          <v-col
            v-if="!isPublic"
            cols="7"
            class="px-4 divider"
          >
            <v-card class="pa-3 elevation-1">
              <v-text-field
                v-model="searchInput"
                placeholder="Filter employee by name"
                append-icon="search"
                label="Search Employee"
                hide-no-data
                hide-selected
              />

              <v-autocomplete
                v-model="filters.positions"
                :items="positions"
                item-text="name"
                item-value="id"
                value="id"
                label="Position"
                placeholder="Filter employee by position"
                clearable
                hide-selected
                multiple
                small-chips
                deletable-chips
                chips
              />

              <v-autocomplete
                v-model="filters.departments"
                :items="departments"
                item-text="name"
                item-value="id"
                value="id"
                label="Department"
                placeholder="Filter employee by department"
                clearable
                hide-selected
                multiple
                deletable-chips
                small-chips
                chips
              />

              <v-data-table
                v-model="selectedEmployees"
                dense
                :loading="tableLoading"
                :headers="headers"
                :items="filteredEmployees"
                hide-default-footer
                fixed-header
                disable-pagination
                show-select 
                item-key="employee_uid"
                item-value="employee_uid"
                class="elevation-2 mb-3"
                height="330px"
              >
                <template v-slot:top>
                  <h5 class="font-weight-bold py-2 mb-0 pl-2">
                    Employee Selection:
                  </h5>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { TiptapVuetify, Heading, Bold, Italic, Underline, BulletList, OrderedList, ListItem, Link, HardBreak } from 'tiptap-vuetify'

  export default {
    components: {
      TiptapVuetify,
      HelperAutoUploadFileInput: () => import('@/components/helper/AutoUploadFileInput'),
    },
    inject: ['$validator'],
    data () {
      return {
        announcementCategories: [],
        isPublished: false,
        isPublic: true,
        acknowledgementRequired: false,
        progressing: false,
        tableLoading: false,
        dialog: null,
        searchInput: '',
        filters: {
          positions: '',
          departments: '',
        },
        positions: [],
        departments: [],
        title: null,
        description: null,
        employees: [],
        selectedEmployees: [],
        file: null,
        announcementDate: null,
        announcementDateMenu: false,
        links: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'person.name',
          },
          {
            text: 'Department',
            align: 'left',
            sortable: true,
            value: 'department.name',
          },
          {
            text: 'Position',
            align: 'left',
            sortable: true,
            value: 'current_position.position.name',
          },        
        ],
        extensions: [
          Link,
          Underline,
          Italic,
          ListItem,
          BulletList,
          OrderedList,
          [Heading, {
            options: {
              levels: [1, 2, 3],
            },
          }],
          Bold,
          HardBreak,
        ],
      }
    },
    computed: {
      filteredEmployees () {
        let _this = this
        _this.searchInput = _this.searchInput.trim()
        let primaryFilterEmployees = this.employees.filter(function (employee) {
          return ((employee.person || {}).name || '').toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1 ||
            ((employee.person || {}).username || '').toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1
        })

        let filteredPositions = this.customFilterPositions(primaryFilterEmployees)
        let filteredStates = this.customFilterDepartments(filteredPositions)
        return filteredStates
      },

      announcementDateDisplay () {
        return this.announcementDate ? this.announcementDate : this.$moment().format('YYYY-MM-DD')
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return       
        this.resetForm()
        this.loadData()
      },
    },
    methods: { 
      loadData () {
        this.tableLoading = true

        Promise.all([
          this.$api.employees().list('?with=active'),
          this.$api.positions().list(),
          this.$api.departments().list(),
          this.$api.announcementCategories().list(),
        ])
          .then(([employees, positions, departments, announcementCategories]) => {
            let temp = employees.data.filter(employee => {
              return employee.department_id !== null
            })

            this.employees = _.orderBy(temp, ['department.name', 'person.name'], ['asc', 'asc'])       
            this.positions = positions.data
            this.departments = departments.data
            this.announcementCategories = announcementCategories.data

            this.tableLoading = false
          })
      },
      prepareFormData () {
        if (this.file) {
          this.file.formData.set('title', this.title)
          this.file.formData.set('description', this.description)
          this.file.formData.set('announcement_date', this.announcementDateDisplay)
          this.file.formData.set('is_published', this.isPublished ? 1 : 0)
          this.file.formData.set('is_public', this.isPublic ? 1 : 0)
          this.file.formData.set('acknowledgement_required', this.acknowledgementRequired ? 1 : 0)
          this.file.formData.set('announcement_category_id', this.announcementCategoryId)
          this.file.formData.set('employeeUids', this.getEmployeeUids())

          if (this.links.length > 0) {
            this.file.formData.set('links', JSON.stringify(this.links))
          }

          return this.file.formData
        }

        let formData = new FormData()

        formData.append('title', this.title)
        formData.append('description', this.description)
        formData.append('announcement_date', this.announcementDateDisplay)
        formData.append('is_published', this.isPublished ? 1 : 0)
        formData.append('is_public', this.isPublic ? 1 : 0)
        formData.append('acknowledgement_required', this.acknowledgementRequired ? 1 : 0)
        formData.append('announcement_category_id', this.announcementCategoryId)
        formData.append('employeeUids', this.getEmployeeUids())

        if (this.links.length > 0) {
          formData.append('links', JSON.stringify(this.links))
        }

        return formData
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
        
            this.$api.announcements().create(this.prepareFormData())
              .then((res) => {
                this.$emit('created')                
                this.$snack({ message: 'Announcement created' })
                
                this.progressing = false
                this.dialog = false                
              })
              .catch(() => {
                this.$snack({ 
                  color: 'error',
                  message: 'Failed to create announcement', 
                })
              })
              .then(() => {
                this.progressing = false
              })
          })
      },

      getEmployeeUids () {
        let employeeUids = []

        this.selectedEmployees.map(item => {
          employeeUids.push(item.employee_uid)
        })

        return employeeUids
      },

      addRow () {
        this.links.push({
          path: '',
        })
      },
      deleteRow (counter) {
        this.links.splice(counter, 1)
      },

      resetForm () {
        this.$validator.reset()
        this.title = null
        this.description = null
        this.announcementCategoryId = null
        this.selectedEmployees = []
        this.searchInput = ''
        this.filters.positions = ''
        this.filters.departments = ''
        this.isPublished = false
        this.isPublic = true
        this.acknowledgementRequired = false
        this.file = null
        this.links = []
      },

      customFilterPositions (employeesList) {
        if (this.filters.positions.length === 0) return employeesList

        return employeesList.filter(employee => {
          let positionId = (employee.current_position || {}).position_id
  
          return _.intersection([positionId], this.filters.positions).length > 0
        })
      },

      customFilterDepartments (employeesList) {
        if (this.filters.departments.length === 0) return employeesList

        return employeesList.filter(employee => {
          return _.intersection([employee.department_id], this.filters.departments).length > 0
        })
      },
    },
  }
</script>

<style scoped>
.divider{
  border-left:1px solid #e6e6e6
}

.text-editor-toolbar-height>>> .v-toolbar__content{
  height: unset !important;
  min-height: 42px;
}
.text-editor-toolbar-height>>>.v-sheet.v-sheet--tile.theme--light.v-toolbar.v-toolbar--dense.v-toolbar--flat.grey.lighten-4{
  min-height:unset !important;
}

 .full-width{
   width: 100%;
 }
</style>
